import React from "react";
import { TableCell } from "@material-ui/core";
import pretty from "Shared/pretty";
import {
  DPReward,
  RewardStatus,
  rewardStatusDictionary,
} from "Shared/types/Rewards";
import { DPLineThroughTableRow } from "Components/DP";
import { RewardActions } from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/RewardsTab/EmployeeRewardsTable/EmployeeRewardsTableRow/RewardActions/RewardActions";
import { ApprovalAction } from "Shared/types/ApprovalActions";

export interface RewardsTableRowProps {
  reward: DPReward;
  employerId: string;
}

export const RewardsTableRow = ({
  reward,
  employerId,
}: RewardsTableRowProps) => {
  const {
    id,
    createdAt,
    requester,
    totalAmountCents,
    employee,
    notes,
    approvedAt,
    claimedAt,
    status,
    employeeProfile: { externalIds, employeeLocation },
    rewardBudget,
  } = reward;
  const isRejected = status === RewardStatus.rejected;
  const primaryExternalId = externalIds.find(externalId => externalId.primary);


  const employeeFullName = pretty.fullName(
    reward.employee.firstName || "",
    reward.employee.lastName || ""
  );

  const { expectedApprovers } = rewardBudget;

  const canApprove =
    status === RewardStatus.pendingApproval &&
      !!expectedApprovers?.filter(expectedApprover => expectedApprover.id === employerId).length;

  return (
    <DPLineThroughTableRow lineThrough={isRejected}>
      <TableCell>
        {createdAt && pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>
        {pretty.fullName(requester.firstName!, requester.lastName!)}
      </TableCell>
      <TableCell>
        {pretty.dollar(totalAmountCents)}
      </TableCell>
      <TableCell>
        {pretty.fullName(employee.firstName!, employee.lastName!)}
      </TableCell>
      <TableCell>
        {employeeLocation?.name || ""}
      </TableCell>
      <TableCell>
        {primaryExternalId?.id}
      </TableCell>
      <TableCell>
        {notes}
      </TableCell>
      <TableCell>
        {approvedAt && pretty.date(approvedAt, { withTime: true })}
      </TableCell>
      <TableCell>
        {claimedAt && pretty.date(claimedAt, { withTime: true })}
      </TableCell>
      <TableCell>
        {rewardStatusDictionary[status as RewardStatus]}
      </TableCell>
      <TableCell align="center">
        {
          canApprove &&
            <RewardActions
              actions={[ApprovalAction.approve, ApprovalAction.reject]}
              employeeFullName={employeeFullName}
              totalAmountCents={totalAmountCents}
              rewardId={id}
              employerId={employerId}
            />
        }
      </TableCell>
    </DPLineThroughTableRow>
  );
};
